import { CommonDataService } from "../DataService/CommonDataService";

export class UnableToConnectManager {

    constructor(private containerElement: JQuery) { }

    public initialize() {
        setInterval(() => {
            CommonDataService.canConnect((result) => {
                if(result) {
                    location.href = "/Company/DataWarehouse"
                }
            })
        }, 5000);
    }

}